import * as React from "react";
function SvgFunnel(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        stroke="currentColor"
        d="M1 3h30L19 17v12h-6V17L1 3z"
      />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgFunnel);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
